import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

/**
 * A minimal, self-styled collapsible section for the dashboard.
 * Renders a clickable header row + smooth height animation for the body.
 * No shadcn dependency — keeps the visual language matching the rest of the
 * dashboard cards (translucent glass, subtle border, rounded-3xl).
 */
const CollapseSection = ({
  title,
  subtitle,
  defaultOpen = true,
  right,
  className = "",
  testId,
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section
      className={`mt-6 rounded-3xl border border-slate-200 bg-white/70 backdrop-blur-md overflow-hidden shadow-sm ${className}`}
      data-testid={testId}
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-4 px-6 py-4 hover:bg-white/50 transition"
        aria-expanded={open}
        data-testid={testId ? `${testId}-toggle` : undefined}
      >
        <div className="text-left">
          <div className="text-[10px] uppercase tracking-[0.3em] text-slate-500 font-semibold">
            {subtitle || "Sezione"}
          </div>
          <h2 className="font-display font-bold text-xl tracking-tight text-slate-900 mt-1">
            {title}
          </h2>
        </div>
        <div className="flex items-center gap-3">
          {right}
          <ChevronDown
            className={`w-5 h-5 text-slate-500 shrink-0 transition-transform ${open ? "rotate-180" : ""}`}
          />
        </div>
      </button>
      <div
        className={`grid transition-all duration-300 ease-out ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
      >
        <div className="overflow-hidden">
          <div className="px-4 md:px-6 pb-6 pt-2">{children}</div>
        </div>
      </div>
    </section>
  );
};

export default CollapseSection;
